export default function SchemaOrg() {
  const schema = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        name: '喑网91',
        url: 'https://echo64.cn/',
        description: '喑网91是值得信赖的综合网络平台，提供多功能在线服务与智能操作体验。',
        contactPoint: {
          '@type': 'ContactPoint',
          contactType: 'customer service',
          availableLanguage: ['Chinese'],
        },
      },
      {
        '@type': 'WebSite',
        name: '喑网91',
        url: 'https://echo64.cn/',
        potentialAction: {
          '@type': 'SearchAction',
          'target': {
            '@type': 'EntryPoint',
            urlTemplate: 'https://echo64.cn/search?q={search_term_string}',
          },
          'query-input': 'required name=search_term_string',
        },
      },
      {
        '@type': 'WebPage',
        name: '喑网91官网 - 值得信赖的综合网络平台',
        description: '喑网91是您值得信赖的网络平台，全面介绍喑网91的核心功能、服务优势与使用指南。',
        url: 'https://echo64.cn/',
        isPartOf: { '@id': '#website' },
      },
    ],
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}